module.exports = __webpack_public_path__ + "img/sForToad_193x205.affa67c3.png";